import React from 'react';
import { useTranslation } from 'react-i18next';

const projects = [
  {
    title: 'Luxury Patio Installation',
    category: 'Pavers',
    image: 'https://images.pexels.com/photos/7658758/pexels-photo-7658758.jpeg',
  },
  {
    title: 'Modern Kitchen Renovation',
    category: 'Kitchen',
    image: 'https://images.unsplash.com/photo-1682888818589-404faaa4dbc9?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Spa-Style Bathroom',
    category: 'Bathroom',
    image: 'https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Contemporary Kitchen Design',
    category: 'Kitchen',
    image: 'https://images.unsplash.com/photo-1682888818650-0a7cbb35287d?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Elegant Bathroom Makeover',
    category: 'Bathroom',
    image: 'https://images.unsplash.com/photo-1758548157466-7c454382035a?crop=entropy&cs=srgb&fm=jpg&q=85',
  },
  {
    title: 'Brick Paver Driveway',
    category: 'Pavers',
    image: 'https://images.pexels.com/photos/17366771/pexels-photo-17366771.jpeg',
  },
];

export const Projects = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="projects-page">
      {/* Hero Section */}
      <section className="py-24 bg-[hsl(210,40%,98%)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1
            className="text-5xl sm:text-6xl font-bold text-[hsl(215,75%,16%)] mb-6 tracking-tight"
            style={{ fontFamily: 'Outfit' }}
          >
            {t('gallery.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-lg card-hover"
                data-testid={`project-card-${index}`}
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end">
                  <div className="p-6 text-white w-full">
                    <span className="inline-block px-3 py-1 bg-[hsl(20,91%,48%)] rounded-full text-xs font-semibold uppercase tracking-wide mb-2">
                      {project.category}
                    </span>
                    <h3
                      className="text-xl font-bold"
                      style={{ fontFamily: 'Outfit' }}
                    >
                      {project.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};